/**
 * The code below is copied from element-ui sources: `ElFormItem`.
 * Known reason - validation message localization problem.
 * Vue options object cannot be merged with exported `ElFormItem`, since it's precompiled.
 * Should be rewritten with normal localization (couldn't do it) and wrap `ElFormItem`, or be buried here forever
 * @summary stay strong, my friend
 */

import _ from 'lodash';
import AsyncValidator, { FieldErrorList } from 'async-validator';
import { getPropByPath } from 'element-ui/src/utils/util';
import Vue from 'vue';

// This block of code is copied from 'element-ui/src/mixins/emitter' and typed. I couldn't find a way to augment exported mixin object with typing
// vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv
function broadcast(this: Vue, componentName: string, eventName: string, params: any[]) {
	(this.$children as any[]).forEach((child) => {
		const name = child.$options.componentName;
		if (name === componentName) {
			// eslint-disable-next-line prefer-spread
			child.$emit.apply(child, [eventName].concat(params));
		} else {
			// @ts-ignore
			broadcast.apply(child, [componentName, eventName].concat([params]));
		}
	});
}

const emitterMixin = {
	methods: {
		dispatch(this: Vue, componentName: string, eventName: string, params: any[]) {
			let parent: any = this.$parent || this.$root;
			let name = parent.$options.componentName;

			while (parent && (!name || name !== componentName)) {
				parent = parent.$parent;

				if (parent) {
					name = parent.$options.componentName;
				}
			}
			if (parent) {
				// eslint-disable-next-line prefer-spread
				parent.$emit.apply(parent, [eventName].concat(params));
			}
		},
		broadcast(this: Vue, componentName: string, eventName: string, params: any[]) {
			broadcast.call(this, componentName, eventName, params);
		},
	},
};
// ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
// This block of code is copied from 'element-ui/src/mixins/emitter' and typed. I couldn't find a way to augment exported mixin object with typing

enum ValidateState {
	error = 'error',
	success = 'success',
	validating = 'validating',
	notValidated = '',
}

interface ValidationRules {
	maska?: string,
	required: boolean,
	recommended: boolean,
	pattern?: string,
	min?: number,
	max?: number,
	len?: number,
	scale?: number,
	precision?: number,
	type: string,
	message?: string,
	isPropertyKeyRequired: boolean;
}

interface DmsFormItemOptionsFakeType {
	props: {
		prop: typeof String,
		editable: typeof Boolean,
		required: {
			type: typeof Boolean,
		},
		rules: [typeof Object, typeof Array],
		error: typeof String,
		validateStatus: typeof String,
		for: typeof String,
		inlineMessage: {
			type: [typeof String, typeof Boolean],
		},
		showMessage: {
			type: typeof Boolean,
		},
	},

	data(): {
		validateState: ValidateState,
		validateMessage: string | null,
		validateDisabled: boolean,
		validator: object,
		isNested: boolean,
		computedLabelWidth: string,
		initialValue: string,
	},

	computed: {
		validateClass(): string | null,
		form(): Vue,
		fieldValue(): string | null,
		isRequired(): boolean,
		allRules(): any[],
		formRules(): ValidationRules,
	},

	methods: {
		validate(trigger: string | string[], callback: (arg1?: any, arg2?: any) => void): true | undefined,
		clearValidate(): void,
		resetField(): void,
		getFilteredRule(trigger: string | string[]): object[],
		onFieldBlur(): void,
		onFieldChange(): void,
		addValidateEvents(): void,
		removeValidateEvents(): void,
		// from emitter mixin
		dispatch(this: Vue, componentName: string, eventName: string, params: any[]): void,
		broadcast(this: Vue, componentName: string, eventName: string, params: any[]): void,
	}
}

interface DmsFormItemInterface {
	// props
	prop: string;
	editable: boolean;
	required: boolean
	rules: object | [];
	error: string;
	validateStatus: string;
	for: string;
	inlineMessage: string | boolean;
	showMessage: boolean;

	// data
	validateState: ValidateState;
	validateMessage: string | null;
	validateDisabled: boolean;
	validator: object;
	isNested: boolean;
	computedLabelWidth: string;
	initialValue: string;

	// computed
	validateClass: string | null,
	form: Vue,
	fieldValue: string | null,
	isRequired: boolean,
	allRules: any[],
	formRules: ValidationRules,

	// methods
	validate(trigger: string | string[], callback?: (arg1?: any, arg2?: any) => void): true | undefined,
	clearValidate(): void,
	resetField(): void,
	getFilteredRule(trigger: string | string[]): any[],
	onFieldBlur(): void,
	onFieldChange(): void,
	addValidateEvents(): void,
	removeValidateEvents(): void,

	// from emitter mixin
	dispatch(this: Vue, componentName: string, eventName: string, params: any | any[]): void,
	broadcast(this: Vue, componentName: string, eventName: string, params: any | any[]): void,
}

export type DmsFormItemType = Vue & DmsFormItemInterface;

export const DmsFormItemConstructor = Vue.extend({
	name: 'DmsFormItem',
	componentName: 'ElFormItem',
	mixins: [emitterMixin],

	provide() {
		return {
			elFormItem: this,
		};
	},

	inject: ['elForm'],

	props: {
		prop: String,
		editable: Boolean,
		required: {
			type: Boolean,
			default: undefined,
		},
		disabled: {
			type: Boolean,
			default: undefined,
		},
		rules: [Object, Array],
		error: String,
		validateStatus: String,
		for: String,
		inlineMessage: {
			type: [String, Boolean],
			default: '',
		},
		showMessage: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			validateState: ValidateState.notValidated,
			validateMessage: '',
			validateDisabled: false,
			validator: {},
			isNested: false,
			computedLabelWidth: '',
			initialValue: '',
		};
	},
	computed: {
		validateClass(this: DmsFormItemType): string | null {
			if (this.validateDisabled || this.validateState === ValidateState.notValidated) {
				return null;
			}

			return `is-${this.validateState}`;
		},
		form(this: DmsFormItemType): Vue {
			let parent = this.$parent;
			let parentName = (parent.$options as any).componentName;
			while (parentName !== 'ElForm') {
				if (parentName === 'ElFormItem') {
					// eslint-disable-next-line vue/no-side-effects-in-computed-properties
					this.isNested = true;
				}
				parent = parent.$parent;
				parentName = (parent.$options as any).componentName;
			}
			return parent;
		},
		fieldValue(this: DmsFormItemType): string | null {
			const { model } = this.form as any;
			if (!model || !this.prop) {
				return null;
			}

			const path = this.prop.replace(/:/, '.');
			return getPropByPath(model, path, true).v;
		},
		isRequired(this: DmsFormItemType): boolean {
			return this.allRules.some((rule) => rule.required);
		},
		formRules(this: DmsFormItemType) {
			let formRules = (this.form as any).rules;
			const prop = getPropByPath(formRules, this.prop || '');
			formRules = formRules ? prop.o[this.prop || ''] || prop.v : [];

			return formRules;
		},
		allRules(this: DmsFormItemType) {
			const selfRules = this.rules;
			const requiredRule = this.required !== undefined ? { required: !!this.required } : [];
			return _.concat([], selfRules ?? [], this.formRules ?? [], requiredRule);
		},
	},
	watch: {
		error: {
			immediate: true,
			handler(this: DmsFormItemType, value: string): void {
				this.validateMessage = value;
				this.validateState = value ? ValidateState.error : ValidateState.notValidated;
			},
		},
		validateStatus(this: DmsFormItemType, value: ValidateState): void {
			this.validateState = value;
		},
	},
	mounted(this: DmsFormItemType): void {
		if (this.prop) {
			this.dispatch('ElForm', 'el.form.addField', [this]);

			let initialValue: any = this.fieldValue;
			if (Array.isArray(initialValue)) {
				initialValue = [].concat(initialValue as any);
			}

			this.initialValue = initialValue!!;
			this.addValidateEvents();
		}
	},
	beforeDestroy(this: DmsFormItemType): void {
		this.dispatch('ElForm', 'el.form.removeField', [this]);
	},
	methods: {
		// eslint-disable-next-line consistent-return
		validate(
			this: DmsFormItemType,
			trigger: string | string[],
			callback: (message?: string | null, invalidFields?: FieldErrorList) => void = function () {},
		): true | undefined {
			this.validateDisabled = false;
			const rules = this.getFilteredRule(trigger);
			if ((!rules || rules.length === 0) && this.required === undefined) {
				callback();
				return true;
			}

			this.validateState = ValidateState.validating;
			const descriptor = {};
			(descriptor as any)[this.prop] = rules.map((rule) => _.omit(rule, ['trigger']));

			const validator = new AsyncValidator(descriptor);

			const model = {};
			(model as any)[this.prop] = this.fieldValue;
			validator.validate(model, { firstFields: true }, (errors, invalidFieldsValidation) => {
				this.validateState = errors ? ValidateState.error : ValidateState.success;
				this.validateMessage = null;

				const formMessage = this.formRules ? this.formRules.message : null;
				if (this.validateState === ValidateState.error) {
					console.warn('validation error', model);
					console.warn(this.formRules, errors);
					if (this.fieldValue === null || this.fieldValue === undefined || this.fieldValue === '') {
						this.formRules.required && (this.validateMessage = this.LocalizeChyboveHlasky('RequiredField'));
					}
					if (errors) {
						const messages = errors.map((e) => e.message).join('\n');
						if (!this.formRules.isPropertyKeyRequired) { this.validateMessage = this.validateMessage?.concat(`\n${messages}`) ?? messages; }
					} else {
						const message = this.LocalizeChyboveHlasky('BadVal');
						this.validateMessage = this.validateMessage?.concat(`\n${message}`) ?? message;
					}
					if (formMessage && this.validateMessage && this.validateMessage.indexOf(formMessage) === -1) { // UI duplicate message display issue fix 5086,5087
						this.validateMessage = this.validateMessage?.concat(`\n${formMessage}`) ?? formMessage;
					}
				}
				callback(this.validateMessage, invalidFieldsValidation);

				const { elForm } = (this as any);
				elForm && elForm.$emit('validate', this.prop, !errors, this.validateMessage || null);
			});
		},
		clearValidate(this: DmsFormItemType): void {
			this.validateState = ValidateState.notValidated;
			this.validateMessage = '';
			this.validateDisabled = false;
		},
		resetField(this: DmsFormItemType): void {
			this.validateState = ValidateState.notValidated;
			this.validateMessage = '';

			const { model } = this.form as any;
			const value = this.fieldValue;
			let path = this.prop;
			if (path.indexOf(':') !== -1) {
				path = path.replace(/:/, '.');
			}

			const prop = getPropByPath(model, path, true);

			this.validateDisabled = true;
			if (Array.isArray(value)) {
				prop.o[prop.k] = [].concat(this.initialValue as any);
			} else {
				prop.o[prop.k] = this.initialValue;
			}

			this.broadcast('ElTimeSelect', 'fieldReset', this.initialValue);
		},
		getFilteredRule(this: DmsFormItemType, trigger: string | string[]) {
			const triggers = Array.isArray(trigger) ? trigger : [trigger];

			return this.allRules
				.filter((rule) => {
					if (!rule.trigger || trigger === '') return true;

					const ruleTriggers = Array.isArray(rule.trigger) ? rule.trigger : [rule.trigger];
					return ruleTriggers.filter((t: string) => triggers.includes(t)).length > 0;
				})
				.map((rule) => _.assign({}, rule));
		},
		onFieldBlur(this: DmsFormItemType) {
			this.validate(['change', 'blur']);
		},
		onFieldChange(this: DmsFormItemType) {
			if (this.validateDisabled) {
				this.validateDisabled = false;
				return;
			}

			this.validate('change');
		},
		addValidateEvents(this: DmsFormItemType) {
			if (this.allRules.length > 0 || this.required !== undefined) {
				this.$on('el.form.blur', this.onFieldBlur);
				this.$on('el.form.change', this.onFieldChange);
			}
		},
		removeValidateEvents(this: DmsFormItemType) {
			this.$off();
		},
	},
} as unknown as DmsFormItemOptionsFakeType);

// eslint-disable-next-line
export default DmsFormItemConstructor;
